import React from 'react';

import './card.scss';

function BlankCard({ cardRef }) {
  return <div className={`card card-stage card--incomplete`} ref={cardRef} />;
}

export default BlankCard;
